import React from 'react';
import classes from './styles/style.module.css';
import { DotLoader } from 'react-spinners';

import { motion } from "framer-motion";

const HubbleSplashScreen = () => {
  return (
    <div className={classes.splashScreenContainer} style={{ backgroundImage: `url('/images/hubble/hubbleSplash.png')`, backgroundPosition: 'center', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }} >
      <motion.img src='/images/hubble/hubbleLogo.png'
        initial={{ opacity: 0, y: -80 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, delay: 0.7 }}
      />
      <motion.div
         initial={{ opacity: 0, y: 80 }}
         animate={{ opacity: 1, y: 0 }}
         transition={{ duration: 0.7, delay: 0.7 }}
      >
        <DotLoader
          color={"#F2AD17"}
          loading="true"
          size={50}
        />
      </motion.div>

    </div>
  )
}

export default HubbleSplashScreen